export default axios => ({
    get(department) {
        return axios.get(`/procedure/${department}`)
    },
    getList(payLoad) {
        return axios.get('/procedure/all', payLoad)
    }
})
